import { getRequest, API } from 'utils/request';

const fetchNextBestUtterance = async ({ queryKey }) => {
  const [, index, callId] = queryKey;
  const res = await getRequest(`${API.utterances}/${callId}/${index}`);
  return res.data;
};

export { fetchNextBestUtterance };
